import * as React from "react";
const SvgFiRrTrain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-train_svg__a)">
      <path
        fill="#062147"
        d="M15 5a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1m6 .72v10.457a5 5 0 0 1-1.326 3.39l1.25 3.054a1 1 0 1 1-1.852.757L18 20.745c-1.878.87-3.93 1.3-6 1.255a13.6 13.6 0 0 1-6-1.255l-1.073 2.633a1 1 0 1 1-1.851-.757l1.249-3.054A5 5 0 0 1 3 16.177V5.72A4.98 4.98 0 0 1 6.475.956C8.257.356 10.12.034 12 0c1.88.034 3.743.357 5.525.957A4.98 4.98 0 0 1 21 5.72m-2 6.017C17.447 14.065 15.05 16 12 16s-5.447-1.935-7-4.263v4.44a2.96 2.96 0 0 0 1.512 2.607A11.3 11.3 0 0 0 12 20a11.3 11.3 0 0 0 5.487-1.216A2.96 2.96 0 0 0 19 16.177zM19 6v-.28a2.99 2.99 0 0 0-2.083-2.858A16.4 16.4 0 0 0 12 2a16.4 16.4 0 0 0-4.917.861A2.99 2.99 0 0 0 5 5.72V6c0 2.443 2.645 8 7 8s7-5.557 7-8m-7 11a1 1 0 1 0 0 1.999A1 1 0 0 0 12 17"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-train_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrain;
